import "./TokyoMap.scss";
import React, { useState, useEffect } from "react";
import districts from "../assets/districts.json";
import { ReactComponent as MapVector } from "../assets/tokyo-map.svg";
import { ReactComponent as RevealedMapVector } from "../assets/map-revealed.svg";
// import gsap from "gsap";
import mixpanel from "mixpanel-browser";
import { trackShare, testTrack } from "../tracker";

function FlipCard({ district }) {
  if (!district) {
    return (
      <div className="district flip-card">
        <h2>Hi!</h2>
        <h3>
          To get started, simply click on any district of the map to learn more
          about it. Enjoy, I hope you find this useful!
        </h3>
      </div>
    );
  }
  const { name, kanji_name, major_districts, famous_for, population } =
    district;
  return (
    <div className="district flip-card _active">
      <div className="district__header">
        <h2>{name}</h2>
        <h3>{kanji_name}</h3>
      </div>
      <div className="district__description">
        <span>home to</span>
        {/* display each famous for point */}
        {famous_for &&
          famous_for.map((point, index) => (
            <div key={index}>
              <h4>
                <span>{point.emoji}</span>
                {point.name}
              </h4>
              <p>{point.description || ""}</p>
            </div>
          ))}
      </div>
      <div className="district__footer">
        <div>
          <span>Major Districts</span>
          <p>{major_districts}</p>
        </div>
        <div>
          <span>Population</span>
          <p>{population}</p>
        </div>
      </div>
    </div>
  );
}
function SpecialWardsMap({ onClick }) {
  function onMapClick(e) {
    const groupSelector = "path[id], g[id]";
    const { target } = e;
    const districtElement = target.matches(groupSelector)
      ? target
      : target.closest(groupSelector);

    if (!districtElement) {
      console.log("Clicked in wrong place");
      console.log(target);
      return;
    }

    [...document.querySelectorAll(groupSelector)].forEach((el) =>
      el.classList.remove("_active")
    );
    districtElement.classList.add("_active");
    districtElement.classList.add("_visited");
    const districtSlug = districtElement.id;
    const district = districts.find((d) => d.slug === districtSlug);
    onClick(district);
  }
  return (
    <div className="special-wards-map">
      <RevealedMapVector />
      <MapVector onClick={onMapClick} />
    </div>
  );
}

export default function TokyoMap() {
  const [districtInfo, setDistrictInfo] = useState(null);
  // const [randomEmoji, setRandomEmoji] = useState(null);

  useEffect(() => {
    testTrack();
    //   fetch("https://emojihub.yurace.pro/api/random/category/activities")
    //     .then((resp) => resp.json())
    //     .then((data) => setRandomEmoji(data));
  }, []);
  //   // this.districts = districts.default;
  // }

  useEffect(() => {
    document.title = "Tokyo Ward Explorer | Daniel Ames";
    console.log("mounted");
    console.log(districts[0]);
    // connect to miuxpanel and send an event
    mixpanel.init("bed4d96111ec66466cf86cd9de076ffd", {
      // debug: true,
      ignore_dnt: true,
    });
    mixpanel.track("Sign up");
    mixpanel.track("Page Viewed", {
      "Page Title": "Home",
      "Page URL": window.location.href,
    });
  }, []);

  const handleMapClick = (district) => {
    setDistrictInfo(district);
    mixpanel.track("Map clicked", { name: district.name });
  };

  return (
    <div className="map">
      <h1>Tokyo Ward Explorer</h1>

      <SpecialWardsMap onClick={handleMapClick} />

      <div className="info-container">
        <FlipCard district={districtInfo} />
      </div>

      <div className="twitter">
        <a
          href="https://twitter.com/intent/tweet?url=https://danie1ames.netlify.app/tokyo&text=Tokyo%20Special%20Wards%20Explorer"
          alt="follow me on twitter"
          target="_blank"
          onClick={trackShare}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
          </svg>
        </a>
      </div>
    </div>
  );
  // }
}
